import React from 'react';
import { Link } from 'react-router-dom';
import './Card.css';

function DreamCard({ category }) {
  return (
    <Link
      to={`/fortune/dream/${category.id}`}
      className="fortune-card"
      style={{ borderColor: category.color, textDecoration: 'none' }}
    >
      <div className="card-emoji" style={{ color: category.color }}>
        {category.emoji}
      </div>
      <h3 className="card-title">{category.name}</h3>
      <p className="card-period">{category.description}</p>
    </Link>
  );
}

export default DreamCard;
